import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '@/src/shared/components/Button';
import Form from '@/src/shared/components/Form';
import RequiredFields from '@/src/shared/components/RequiredFields';
import { space } from '@/styles';
import submitQuestion from '../../redux/actions';
import FormFields from './FormFields';

const { m } = space;

const ContactUsForm = props => {
  const { form } = props;

  const submit = async e => {
    if (e && 'preventDefault' in e) e.preventDefault();

    await form.validateFieldsAndScroll(async (err, values) => {
      if (err) throw err;

      const {
        Name,
        Company,
        Phone,
        EmailAddress,
        Subject,
        TypeCode,
        CommentQuestion,
        ReCaptcha,
      } = values;

      const payload = {
        TypeCode,
        Subject,
        CommentQuestion,
        ReCaptcha,
        RequestorInformation: {
          PersonId: null,
          Name,
          Company,
          Phone,
          EmailAddress,
        },
      };
      props.submitQuestion(payload);
    });
  };
  return (
    <>
      <Form onSubmit={submit} theme="white">
        <FormFields form={form} />
        <Form.Item>
          <Button htmlType="submit" type="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
      <div css={m.t32}>
        <RequiredFields />
      </div>
    </>
  );
};

ContactUsForm.propTypes = {};

export default connect(
  undefined,
  { submitQuestion }
)(Form.create({ name: 'ContactUsForm' })(ContactUsForm));
